export default class CookieCreator {
    constructor() {}
    sendCookie(cookieParams) {}
    removeCookies(affiliates) {}
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/CookieCreator.js